<!-- eslint-disable @angular-eslint/template/no-call-expression -->
@let showControls = slice?.settings?.general?.accessibility?.showControls;
<div
  class="slice-marquee-wrapper"
  [ngClass]="showControls ? 'slice-marquee-wrapper-' + slice?.settings?.general?.accessibility?.controlButtonPosition : ''">
  @if (showControls) {
    <button
      class="slice-marquee-control"
      type="button"
      tabindex="0"
      [attr.aria-label]="getAutoplaylButtonAriaLabel()"
      (click)="autoplayClick()"
      (keydown)="onKeyDown($event)">
      @let autoplay = swiperContainer()?.nativeElement?.swiper?.autoplay;
      @if (isMobile && autoplay) {
        @if (!autoplay.running) {
          <svg
            class="play-icon"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <rect
              rx="12"
              fill="white"
              fill-opacity="0.6"/>
            <path
              d="M18.1875 11.6748C18.4375 11.8191 18.4375 12.1809 18.1875 12.3252L9.1875 17.5205C8.93754 17.6648 8.6251 17.4849 8.625 17.1963L8.625 6.80371C8.6251 6.51512 8.93754 6.33518 9.1875 6.47949L18.1875 11.6748Z"
              stroke="black"
              stroke-width="0.75"/>
          </svg>
        } @else {
          <svg
            class="pause-icon"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <rect
              rx="12"
              fill="white"
              fill-opacity="0.6"/>
            <rect
              x="8.25"
              y="6.23242"
              rx="1.125"
              stroke="black"
              stroke-width="0.75"
              stroke-linejoin="round"/>
            <rect
              x="13.5"
              y="6.23242"
              rx="1.125"
              stroke="black"
              stroke-width="0.75"
              stroke-linejoin="round"/>
          </svg>
        }
      }
      @if (!isMobile && autoplay) {
        @if (!autoplay.running) {
          <svg
            class="play-icon"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <rect
              rx="16"
              fill="white"
              fill-opacity="0.6"/>
            <path
              d="M24.25 15.5674C24.5831 15.7599 24.5831 16.2401 24.25 16.4326L12.25 23.3613C11.9167 23.5537 11.5 23.3126 11.5 22.9277L11.5 9.07226C11.5 8.68738 11.9167 8.44627 12.25 8.63867L24.25 15.5674Z"
              stroke="black"/>
          </svg>
        } @else {
          <svg
            class="pause-icon"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <rect
              rx="16"
              fill="white"
              fill-opacity="0.6"/>
            <rect
              x="11"
              y="8.31006"
              rx="1.5"
              stroke="black"
              stroke-linejoin="round"/>
            <rect
              x="18"
              y="8.31006"
              rx="1.5"
              stroke="black"
              stroke-linejoin="round"/>
          </svg>
        }
      }
    </button>
  }

  @if (slidesRange.length > 0) {
    <div
      #swiper
      cmsSwiper
      class="swiper-container"
      [ngClass]="slice?.settings?.general?.accessibility?.showControls ? 'swiper-container-'+slice?.settings?.general?.accessibility?.controlButtonPosition : ''"
      [config]="swiperConfig"
      role="region"
      aria-live="polite">
      <div class="swiper-wrapper">
        @if (slidesRange.length === 1) {
          @for (slide of singleSlide; track $index) {
            <div
              class="swiper-slide"
              role="group">
              <render-slice-slot
                data-e2e="render-slice-slot"
                [slice]="slice"
                [slot]="(slide + 1).toString()"
                [ngStyle]="getSlotStyles(slots[slide])">
              </render-slice-slot>
            </div>
        }
        } @else {
          @for (slide of slidesRange; track $index) {
            <div
              class="swiper-slide"
              role="group">
              <render-slice-slot
                data-e2e="render-slice-slot"
                [slice]="slice"
                [slot]="(slide + 1).toString()"
                [ngStyle]="getSlotStyles(slots[slide])">
              </render-slice-slot>
            </div>
          }
        }
      </div>
    </div>
  }

</div>


